module.exports = __webpack_public_path__ + "img/p-two-step-04.b0ad5dfe.png";